/**
 * 配置API服务（用户端）
 * @description 前端用户页面获取系统配置的API
 * @since 2025-12-27
 */

import { httpClient } from '@/utils/request'

// ═══════════════════════════════════════════════════
// 类型定义
// ═══════════════════════════════════════════════════

/** 公开配置响应数据 */
export interface PublicConfigData {
  toggles: {
    maintenance_mode: boolean
    allow_register: boolean
    allow_withdraw: boolean
    allow_upload: boolean
    allow_publish: boolean
  }
  vipPrice: {
    individual: { yearly: number, lifetime: number }
    company: { yearly: number, lifetime: number }
  }
  uploadLimits: {
    maxSizeMb: number
    maxImages: number
  }
  version: number
}

/** 用户配置响应数据 */
export interface UserConfigData {
  commission: {
    model: { normal: number, vip: number }
    task: { normal: number, vip: number }
    withdraw: { rate: number, minimum: number }
  }
  points: {
    exchange: { rate: number }
    recharge: { rate: number }
    vip: { multiplier: number }
  }
  taskRules: {
    bid: { dailyLimit: number }
    freeCommission: { remaining: number }
  }
  signin: { points: number }
  bidRemaining: number
  userVipLevel: 'normal' | 'vip'
}

// ═══════════════════════════════════════════════════
// API函数
// ═══════════════════════════════════════════════════

const BASE_URL = '/config'

/**
 * 获取公开配置（无需登录）
 * 包含系统开关、VIP价格、上传限制
 */
export async function getPublicConfig(): Promise<PublicConfigData> {
  return httpClient.get<PublicConfigData>(`${BASE_URL}/public`)
}

/**
 * 获取用户配置（需要登录）
 * 包含佣金、积分、投标限制等
 */
export async function getUserConfig(): Promise<UserConfigData> {
  return httpClient.get<UserConfigData>('/users/me/config')
}
